export interface IGetPatientByCodeRequest{
    codigo: string;
}